import { estadoService } from '../_services/';

export const estadoAction = {
    getEstadosSelect
};

function getEstadosSelect() {
    return dispatch => {
        let apiEndpoint = 'estados/select';
        estadoService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Text: 'SELECIONE...', Value: '' })
                dispatch(changeEstadosList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}
export function changeEstadosList(estado) {
    return {
        type: "FETECHED_ALL_ESTADO",
        estado: estado
    }
}
export function editEstadosDetails(estado) {
    return {
        type: "ESTADO_DETAIL",
        id: estado.id,
        nome: estado.nome,
        uf: estado.uf,
        data_exclusao: estado.data_exclusao,
        usuario_exclusao: estado.usuario_exclusao,
        ibge: estado.ibge
    }
}